import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/error-filled",
  "use": "app/error-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/error-filled\"><path d=\"M12 0A12 12 0 00.92 7.4a11.8 11.8 0 00-.68 6.94 12 12 0 009.42 9.42 11.8 11.8 0 006.94-.68A12 12 0 0012 0zm0 21.34a2.58 2.58 0 01-1.42-.44 2.52 2.52 0 01-1.154-2.255A2.58 2.58 0 0111.5 16.24a2.5 2.5 0 011.48.16 2.44 2.44 0 011.16.94 2.58 2.58 0 01-2.14 4zm2.16-7.66H10l-.62-10h5.38l-.6 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol